export type Poster = { src: string; srcset: string; sizes: string }
export type PosterData =
	| Poster
	| { url: string; widths: string; startingWidth: number; sizes: string }

export function resolvePoster(data: PosterData): Poster {
	if ('src' in data) return data
	return {
		src: data.url.replaceAll('{width}', String(data.startingWidth)),
		srcset: data.widths
			.split(',')
			.map(
				(width) =>
					`${data.url.replaceAll('{width}', String(Number(width.trim())))} ${width}w`
			)
			.join(', '),
		sizes: data.sizes,
	}
}

export function decodePoster(image: HTMLImageElement): Promise<boolean> {
	image.loading = 'eager'
	return new Promise((resolve) => {
		const finish = (decoded: boolean) => {
			window.clearTimeout(timer)
			image.removeEventListener('load', decode)
			image.removeEventListener('error', fail)
			resolve(decoded)
		}
		const fail = () => finish(false)
		const decode = () => {
			const source = image.currentSrc
			void image.decode().then(
				() => { if (image.currentSrc === source) finish(image.naturalWidth > 0) },
				() => { if (image.currentSrc === source && image.complete) finish(false) }
			)
		}
		const timer = window.setTimeout(fail, 8000)
		image.addEventListener('load', decode)
		image.addEventListener('error', fail)
		if (image.complete) {
			if (image.naturalWidth > 0) decode()
			else fail()
		}
	})
}
